export default __webpack_public_path__ + "static/media/partner1.ff46a38d.png";